<template>
  <div class="modal" v-show="modal" @click="selectedFalseFn">
    <div class="modal-wraper" :class="{'score-modal-wraper':type == 6}">
      <div class="sign-modal modal-item">
        <div class="sign-title modal-title">
          <span class="text">{{ $t("system.title") }}</span>
          <input v-model="title" class="input" type="text" ref="title-text" autofocus />
        </div>
        <div class="sign-class modal-class">
          <span class="text">{{ $t("system.class") }}</span>
          <span
            class="input class"
            @click="selectClass"
            v-show="!chooseClass"
            :class="noChooseClass==true?'no-choose-class':''"
          >
            <span class="default" v-if="classSelectSure.length==0">{{ $t("system.chooseClass") }}</span>
            <span class="text" v-if="classSelectSure.length==1">
              <span class="one">{{classSelectSure[0]}}</span>
            </span>
            <span class="text" v-if="classSelectSure.length>1">
              <span class="two">{{classSelectSure[0]}}</span>
              <span class="three">{{ $t("system.tip1", { num: classSelectSure.length }) }}</span>
            </span>
            <span class="iconfont icon-yemian-yizhankai"></span>
          </span>
          <div class="classes-modal" v-show="chooseClass">
            <div class="classes-list">
              <div class="close-cls-modal" @click="selectCancle">
                <span class="iconfont icon-guanbi"></span>
              </div>
              <CheckboxGroup
                v-model="classSelect"
                class="class-wraper"
                v-scrollBar
                v-if="classList.length>0"
              >
                <Checkbox
                  class="item-class"
                  v-for="item in classList"
                  :key="item.classId"
                  :label="item.className"
                  :data-classId="item.classId"
                ></Checkbox>
              </CheckboxGroup>
              <div class="no-clist" v-if="classList.length==0">{{ $t("system.tip2") }}</div>
              <div class="operation">
                <span class="sure" @click="selectedSure">{{ $t("system.confirm") }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="sign-people modal-people" v-if="type == 3">
          <span class="text">{{ $t("system.peopleNum") }}</span>
          <div class="person-num">
            <span class="default" @click="selectedPerson">
              <span>{{ $t("system.peopleOf", { n: personNum }) }}</span>
              <span class="iconfont icon-sanjiao"></span>
            </span>
            <div class="person-selected" v-scrollBar v-show="numSelected">
              <span
                v-for="item in 10"
                :key="item"
                :class="personNum == item?'person-choose':''"
                @click="selectedTrue(item)"
              >{{ $t("system.peopleOf", { n: item }) }}</span>
            </div>
          </div>
        </div>
        <div v-if="type == 2">
          <div class="sign-choose modal-choose">
            <div class="text">{{ $t("system.option") }}</div>
            <div class="max-choose" @click.stop="startSelect">
            <span>{{chooseText}}</span>
            <span class="iconfont icon-sanjiao"></span>
            <ul class="max-choose-list" v-show="isSelected">
              <li
                v-for="item in chooseList.length-1"
                :key="item"
                :class="item == chooseItem?'selected':''"
                @click="chooseSelect(item)"
              >{{ $t("system.tip3", { num: item }) }}</li>
            </ul>
          </div>
          </div>
          <div class="modal-choose">
            <span class="text"></span>
            <div class="sign-choose-list">
              <ul>
                <li v-for="(item,index) in chooseList" :key="index">
                  <span class="option">{{item.option}}</span>
                  <input
                    class="text"
                    type="text"
                    :placeholder="$t('system.tip4')"
                    v-model.trim="item.text"
                  />
                  <span
                    class="iconfont icon-lei_guanbi del-choose"
                    v-if="index>=2"
                    @click="delChoose(index)"
                  ></span>
                </li>
              </ul>
              <div class="add-choose" @click="addChoose">
                <span class="iconfont icon-jiahao"></span>
                <span>{{ $t("system.option") }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="type == 6">
          <div class="score-object-type modal-score">
            <span class="text">{{ $t("system.object") }}</span>
            <div class="score-type-wra">
              <span
                v-for="(item,index) in scoreTypeList"
                :key="'type' + index"
                :class="{ active: index + 1 == scoreType }"
                class="type"
                @click="changeScoreType(index+1)"
              >{{item}}</span>
            </div>
          </div>
          <div class="score-item modal-score">
            <span class="text"></span>
            <div class="item-wra">
              <div class="checkbox custom-checkbox">
                <label>
                  <input type="checkbox" :checked="isScoreItem" @change="changeIsItem" />
                  <span class="iconfont icon-zhongduigou mark"></span>
                  <span class="label-text">{{ $t("system.scoreSubitem") }}</span>
                </label>
              </div>
              <div class="score-item-list" v-if="isScoreItem">
                <ul class="item-ul">
                  <li v-for="(item,index) in scoreItemList" :key="index" class="clearfix">
                    <span
                      class="iconfont icon-lei_guanbi left"
                      v-if="index>=1"
                      @click="delScoreItem(index)"
                    ></span>
                    <span class="option left">{{index+1}}</span>
                    <input
                      class="input content-input left"
                      type="text"
                      :placeholder="$t('system.enterPoint')"
                      v-model.trim="item.title"
                    />
                    <input
                      class="input value-input left"
                      type="text"
                      :placeholder="$t('system.score')"
                      :size="$t('system.score').length"
                      v-model.trim="item.score"
                      @input="checkScoreInput(index)"
                    />
                    <p class="err-tip" v-if="item.errTip">{{item.errTip}}</p>
                  </li>
                </ul>
                <div class="add-choose clearfix">
                  <span class="add-score" @click="addScoreItem">
                    <i class="iconfont icon-jiahao"></i>
                    {{ $t("system.addPoint") }}
                  </span>
                  <i18n class="left-score" path="system.tips5">
                    <i class="left-score" slot="score">{{leftScore > 0 ? leftScore : 0}}</i>
                  </i18n>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="start">
        <span
          @click="startActivity"
          :class="classIds.length>0 && title?'can-start':''"
        >{{ $t("system.startNow") }}</span>
      </div>
      <div class="close" @click="closeModal">
        <span class="iconfont icon-guanbi"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "modal",
  props: {
    type: Number,
    modal: Boolean,
    modalTitle: String
  },
  data() {
    return {
      classList: [],
      classSelect: [],
      classSelectSure: [],
      chooseList: [{ option: "A", text: "" }, { option: "B", text: "" }],
      isSelected: false,
      chooseItem: 1,
      chooseText: "",
      chooseClass: false,
      classIds: [],
      title: "",
      userId: 0,
      personNum: 5,
      numSelected: false,
      noChooseClass: false,
      limitTime: 1,
      scoreTypeList: [
        this.$t("system.student"),
        this.$t("system.group"),
        this.$t("system.other")
      ],
      scoreType: 1,
      isScoreItem: false,
      scoreItemList: [{ title: "", score: "" }]
    };
  },
  methods: {
    selectedFalseFn(){
      if(this.isSelected){
        this.isSelected = false
      }
    },
    closeModal: function() {
      this.$emit("closeModal");
      this.chooseItem = 1;
      this.chooseList = [{ option: "A", text: "" }, { option: "B", text: "" }];
      this.scoreType = 1;
      this.isScoreItem = false;
      this.scoreItemList = [{ title: "", score: "" }];
    },
    selectedSure: function() {
      this.noChooseClass = false;
      this.classSelectSure = this.classSelect;
      this.classIds = [];
      this.classItems = [];
      var eleArr = $(".ivu-checkbox-wrapper-checked");
      for (var i = 0; i < eleArr.length; i++) {
        this.classIds.push(parseInt($(eleArr[i]).attr("data-classid")));
        this.classItems.push({
          classId: parseInt($(eleArr[i]).attr("data-classid")),
          className: $(eleArr[i])
            .find("input")
            .val()
        });
      }
      this.chooseClass = false;
    },
    selectCancle: function() {
      this.chooseClass = false;
      this.classIds = [];
      this.classItems = [];
      this.classSelect = [];
    },
    selectClass: function() {
      this.chooseClass = true;
      this.classSelect = this.classSelectSure;
    },
    startSelect: function() {
      this.isSelected = !this.isSelected;
    },
    chooseSelect: function(index) {
      this.chooseItem = index;
      this.chooseText = this.$t("system.tip3", { num: index });
      this.isSelected = false;
    },
    selectedPerson: function() {
      this.numSelected = !this.numSelected;
    },
    selectedTrue: function(num) {
      this.personNum = num;
      this.numSelected = false;
    },
    //增加试题选项
    addChoose: function() {
      if (this.chooseList.length < 10) {
        var newChoice = {
          text: ""
        };
        this.chooseList.push(newChoice);
        for (var i = 0; i < this.chooseList.length; i++) {
          this.chooseList[i].option = String.fromCharCode(
            "A".charCodeAt(0) + i
          ); //增加ABCD选项
        }
      } else {
        this.$Message.warning(this.$t("system.tip6"));
      }
    },
    //删除试题选行
    delChoose: function(index) {
      this.chooseList.splice(index, 1);
      for (var i = 0; i < this.chooseList.length; i++) {
        this.chooseList[i].option = String.fromCharCode("A".charCodeAt(0) + i); //增加ABCD选项
      }
    },
    //选择打分对象类型
    changeScoreType: function(type) {
      this.scoreType = type;
    },
    //是否开始分项评分
    changeIsItem: function() {
      this.isScoreItem = !this.isScoreItem;
    },
    // 添加评分规则
    addScoreItem: function() {
      this.scoreItemList.push({ title: "", score: "" });
    },
    //删除评分规则
    delScoreItem: function(index) {
      this.scoreItemList.splice(index, 1);
    },
    //检查输入的分数
    checkScoreInput: function(index) {
      let item = this.scoreItemList[index];
      const reg = /^\d{0,8}$/;
      if (!reg.test(item.score)) {
        item.errTip = this.$t("system.tip7");
      } else if (this.leftScore < 0) {
        item.errTip = this.$t("system.tip8");
      } else {
        item.errTip = "";
      }
    },
    //发起活动
    startActivity: function() {
      if (this.classIds.length == 0) {
        //    this.$Message.warning('请选择班级');
        this.noChooseClass = true;
        return;
      }
      if (this.title.length == 0) {
        return;
      }
      //    if(this.activityType == 2){
      //       for(var i = 0; i < this.chooseList.length; i++){
      //         if(this.chooseList[i].text == ''){
      //             this.$Message.warning('选项不能为空');
      //             return;
      //         }
      //       }
      //    }
      if (this.limitTime == 1) {
        switch (this.activityType) {
          case 1:
            this.startSignAct();
            break;
          case 2:
            this.startVoteAct();
            break;
          case 3:
            this.startResponderAct();
            break;
          case 4:
            this.startDiscussAct();
            break;
          case 5:
            this.startPick();
            break;
          case 6:
            this.startScore();
            break;
          default:
            break;
        }
      }
    },
    //发起签到
    startSignAct: function() {
      var userId = this.userId;
      var that = this;
      if (that.title.length > 200) {
        this.$Message.warning(this.$t("system.tip9"));
        return;
      }
      that.limitTime = 0;
      that.$http
        .post(that.baseURL1 + "/newAttendance/publishClassesAttendanceRecord", {
          location: "116.14,39.91",
          userID: userId,
          time: -1,
          growth: 0,
          classID: that.classIds,
          type: 1,
          refreshCode: 1,
          refreshCodeTime: 15,
          draft: 0,
          isGPS: false,
          title: that.title,
          from: "pc"
        })
        .then(res => {
          if (res.data.attendanceID > 0) {
            that.common.setCookie("activityId", res.data.attendanceID);
            that.common.setCookie("type", 1);
            that.closeModal();
            that.appScreen(userId, 1, res.data.attendanceID);
          } else {
            this.$Message.warning(this.$t("system.startFail"));
          }
          that.limitTime = 1;
        });
    },
    //发起投票
    startVoteAct: function() {
      var classIds = this.classIds;
      var options = [];
      if (this.title.length > 200) {
        this.$Message.warning(this.$t("system.tip9"));
        return;
      }
      for (var i = 0; i < this.chooseList.length; i++) {
        options.push({
          type: 1,
          value: this.chooseList[i].text
        });
      }
      var vote = {
        id: 0,
        userId: this.userId,
        title: this.title,
        state: 2,
        selectableCount: this.chooseItem,
        growth: 0,
        startDate: 0,
        endDate: 0,
        duration: 86400000
      };
      var that = this;
      that.limitTime = 0;
      that.$http
        .post(that.baseURL1 + "/voteV2/save", {
          userId: this.userId,
          vote: vote,
          classIds: classIds,
          options: options
        })
        .then(res => {
          if (res.data.success) {
            that.common.setCookie("activityId", res.data.voteId);
            that.common.setCookie("type", 2);
            that.closeModal();
            that.appScreen(that.userId, 2, res.data.voteId);
          } else {
            this.$Message.warning(this.$t("system.startFail"));
          }
          that.limitTime = 1;
        });
    },
    //发起抢答
    startResponderAct: function() {
      var userId = this.userId;
      var that = this;
      if (that.title.length > 200) {
        this.$Message.warning(this.$t("system.tip9"));
        return;
      }
      that.limitTime = 0;
      that.$http
        .post(that.baseURL1 + "/interlocution/publish", {
          type: 1,
          userId: userId,
          title: that.title,
          classes: that.classItems,
          count: that.personNum
        })
        .then(res => {
          if (res.data.interlocutionId > 0) {
            that.common.setCookie("activityId", res.data.interlocutionId);
            that.common.setCookie("type", 3);
            that.closeModal();
            that.appScreen(userId, 3, res.data.interlocutionId);
          } else {
            this.$Message.warning(this.$t("system.startFail"));
          }
          that.limitTime = 1;
        });
    },
    //发起讨论
    startDiscussAct: function() {
      var that = this;
      if (that.title.length > 200) {
        this.$Message.warning(this.$t("system.tip9"));
        return;
      }
      that.limitTime = 0;
      that.$http
        .post(that.baseURL1 + "/discussion/publishTopic", {
          title: that.title,
          classesID: that.classIds.join(","),
          isLimitDiscussTime: 1,
          userID: this.userId,
          discussType: 0
        })
        .then(res => {
          if (res.data > 0) {
            that.common.setCookie("activityId", res.data);
            that.common.setCookie("type", 4);
            that.closeModal();
            that.appScreen(that.userId, 4, res.data);
          } else {
            this.$Message.warning(this.$t("system.startFail"));
          }
          that.limitTime = 1;
        });
    },
    // 发起选人
    startPick() {
      let that = this;
      if (that.title.length > 200) {
        this.$Message.warning(this.$t("system.tip9"));
        return;
      }
      that.limitTime = 0;
      that.$http
        .post(that.baseURL1 + "/selectperson/publish", {
          title: that.title,
          selectPersonId: -1,
          userId: this.userId,
          draft: 0,
          classes: that.classItems
        })
        .then(res => {
          if (res.data.code === 200) {
            that.common.setCookie("activityId", res.data.id);
            that.common.setCookie("type", 5);
            that.closeModal();
            that.appScreen(that.userId, 5, res.data.id);
          } else {
            that.$Message.warning(this.$t("system.startFail"));
          }
          that.limitTime = 1;
        });
    },
    // 发起打分
    startScore() {
      let that = this;
      let errTip = "";
      if (that.title.length > 200) {
        errTip = this.$t("system.tip9");
      } else if (this.isScoreItem) {
        if (this.leftScore > 0) {
          errTip = this.$t("system.tip10");
        }
        this.scoreItemList.forEach(item => {
          if (!item.title) {
            errTip = this.$t("system.tip11");
            return;
          } else if (item.errTip) {
            errTip = this.$t("system.tip7");
            return;
          }
        });
      }
      if (errTip) {
        that.$Message.warning(errTip);
        return;
      }
      that.limitTime = 0;
      let scoreModel = {
        classScoreId: -1,
        userId: this.userId,
        title: this.title,
        draft: 0,
        type: this.scoreType,
        description: "",
        isSubentry: this.isScoreItem ? 1 : 0,
        subentry: JSON.stringify(this.scoreItemList),
        classes: this.classItems
      };
      that.$http
        .post(that.baseURL1 + "/classscore/publish", scoreModel)
        .then(res => {
          if (res.data.code === 200) {
            that.common.setCookie("activityId", res.data.id);
            that.common.setCookie("type", 6);
            that.closeModal();
            that.appScreen(that.userId, 6, res.data.id);
          } else {
            that.$Message.warning(this.$t("system.startFail"));
          }
          that.limitTime = 1;
        });
    },
    //活动发起成功后发送投屏请求
    appScreen: function(userId, type, activityId) {
      var that = this;
      var Authorization = this.common.getCookie("Authorization");
      that.$http
        .post(
          that.baseURL + "/appscreen/createScreen",
          {
            userId: userId,
            type: type,
            activityId: activityId,
            sender: "pc"
          },
          {
            headers: {
              Authorization: Authorization
            }
          }
        )
        .then(res => {
          switch (type) {
            case 1:
              if (window.location.href.indexOf("/screenIndex/signIn") != -1) {
                window.location.reload();
              } else {
                this.$router.replace({ path: "/screenIndex/signIn" });
              }
              break;
            case 2:
              if (window.location.href.indexOf("/screenIndex/vote") != -1) {
                window.location.reload();
              } else {
                this.$router.replace({ path: "/screenIndex/vote" });
              }
              break;
            case 3:
              if (
                window.location.href.indexOf("/screenIndex/responder") != -1
              ) {
                window.location.reload();
              } else {
                this.$router.replace({ path: "/screenIndex/responder" });
              }
              break;
            case 4:
              if (window.location.href.indexOf("/screenIndex/discuss") != -1) {
                window.location.reload();
              } else {
                this.$router.replace({ path: "/screenIndex/discuss" });
              }
              break;
            case 5:
              if (window.location.href.indexOf("/screenIndex/pick") != -1) {
                window.location.reload();
              } else {
                this.$router.replace({ path: "/screenIndex/pick" });
              }
              break;
            case 6:
              if (window.location.hash == "#/screenIndex/score") {
                window.location.reload();
              } else {
                this.$router.replace({ path: "/screenIndex/score" });
              }
              break;
            case 7:
              if (window.location.hash == "#/screenIndex/resource") {
                window.location.reload();
              } else {
                this.$router.replace({ path: "/screenIndex/resource" });
              }
              break;
            default:
              break;
          }
        });
    }
  },
  computed: {
    leftScore() {
      let totalScore = 0;
      this.scoreItemList.forEach(item => {
        totalScore += item.score > 0 ? parseInt(item.score) : 0;
      });
      return 100 - totalScore;
    }
  },
  mounted: function() {
    this.chooseText = this.$t("system.tip3", { num: 1 });
  },
  created: function() {
    var userID = this.common.getCookie("userId");
    this.userId = userID;
    var ocId = this.common.getCookie("ocId");
    var Authorization = this.common.getCookie("Authorization");
    var that = this;
    //获取班级列表
    //{ocId}
    if (ocId) {
      that.$http
        .get(that.baseURL + "/teachingteam/" + ocId + "?pn=1&ps=100", {
          headers: {
            Authorization: Authorization
          }
        })
        .then(res => {
          var data = res.data.list;
          for (var i = 0; i < data.length; i++) {
            if (userID == data[i].userId) {
              that.classList = data[i].classes;
            }
          }
        });
    }
  },
  watch: {
    type(newVal, oldVal) {
      this.activityType = newVal;
    },
    modalTitle(newVal, oldVal) {
      this.title = newVal;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "modal.scss";
</style>



// WEBPACK FOOTER //
// src/components/modal/modal.vue